import { getMarkerStyles } from 'app/core/markers/models';
import { strokeMarkerRenderer } from './painters';
export const renderEllipseMarker = (marker, opts, ctx) => {
    const item = marker;
    const painter = (pCtx) => {
        const cx = item.endX * 0.5;
        const cy = item.endY * 0.5;
        pCtx.beginPath();
        pCtx.ellipse(cx, cy, Math.abs(cx), Math.abs(cy), 0, 0, 2 * Math.PI);
        pCtx.closePath();
    };
    ctx.save();
    ctx.translate(item.x, item.y);
    strokeMarkerRenderer(ctx, getMarkerStyles(marker), painter, opts);
    ctx.restore();
};
